<template>
  <div class="search-preloader">
    <div>
      <span></span>
    </div>
    <div>
      <span></span>
    </div>
    <div>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPreloader'
};
</script>

<style lang="less">
.search-preloader {
  width: 190px;
  height: 120px;
  margin: 80px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-height: 600px) {
    margin: 40px 0;
  }

  div,
  span {
    position: absolute;
  }

  div {
    top: 30px;
    left: 50%;
    width: 60px;
    height: 60px;
    animation: rotate 6.9s linear infinite;

    span {
      left: -8px;
      top: 50%;
      margin: -8px 0 0 0;
      width: 25px;
      height: 25px;
      display: block;
      background: #0b96e9;
      box-shadow: 2px 2px 8px rgba(#0b96e9, 0.09);
      border-radius: 50%;
      transform: rotate(90deg);
      animation: move 6.9s linear infinite;

      &:before,
      &:after {
        content: '';
        position: absolute;
        display: block;
        border-radius: 50%;
        width: 23px;
        height: 23px;
        background: inherit;
        top: 50%;
        left: 50%;
        margin: -11.5px 0 0 -11.5px;
        box-shadow: inherit;
      }

      &:before {
        animation: drop1 0.8s linear infinite;
      }

      &:after {
        animation: drop2 0.8s linear infinite 0.4s;
      }
    }

    &:nth-child(2) {
      animation-delay: -2.3s;

      span {
        animation-delay: -2.3s;
      }
    }

    &:nth-child(3) {
      animation-delay: -4.6s;

      span {
        animation-delay: -4.6s;
      }
    }
  }
}

@keyframes moveSvg {
  0% {
    offset-distance: 0%;
  }

  25% {
    background: #d5eefd;
  }

  75% {
    background: #23c4f8;
  }

  100% {
    offset-distance: 100%;
  }
}

@keyframes rotate {
  50% {
    transform: rotate(360deg);
    margin-left: 0;
  }

  50.0001%,
  100% {
    margin-left: -60px;
  }
}

@keyframes move {
  0%,
  50% {
    left: -12.5px;
  }

  25% {
    background: #d5eefd;
  }

  75% {
    background: #23c4f8;
  }

  50.0001%,
  100% {
    left: auto;
    right: -12.5px;
  }
}

@keyframes drop1 {
  100% {
    transform: translate(50px, 12.5px) scale(0);
  }
}

@keyframes drop2 {
  0% {
    transform: translate(0, 0) scale(0.9);
  }

  100% {
    transform: translate(50px, -12.5px) scale(0);
  }
}
</style>
